import { render, staticRenderFns } from "./DashboardProjects.vue?vue&type=template&id=a48b2722&scoped=true&"
import script from "./DashboardProjects.vue?vue&type=script&lang=js&"
export * from "./DashboardProjects.vue?vue&type=script&lang=js&"
import style0 from "./DashboardProjects.vue?vue&type=style&index=0&id=a48b2722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48b2722",
  null
  
)

export default component.exports